import { render, staticRenderFns } from "./add-survey.vue?vue&type=template&id=4962de6d&scoped=true"
import script from "./add-survey.vue?vue&type=script&lang=js"
export * from "./add-survey.vue?vue&type=script&lang=js"
import style0 from "./add-survey.vue?vue&type=style&index=0&id=4962de6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4962de6d",
  null
  
)

export default component.exports